import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface PropertyBasicInfoProps {
  formData: {
    title: string;
    shortName: string;
    name: string;
    shortDescription: string;
    longDescription: string;
    airbnbUrl: string;
    price: number;
    cleaningFee: number;
    rating: number;
    propertyFloor: string;
  };
  onInputChange: (field: string, value: any) => void;
  canEdit?: boolean;
}

const PropertyBasicInfo = ({
  formData,
  onInputChange,
  canEdit = false,
}: PropertyBasicInfoProps) => {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="title">Título *</Label>
        <Input
          id="title"
          value={formData.title}
          onChange={(e) => onInputChange("title", e.target.value)}
          placeholder="Título de la propiedad"
          required
        />
      </div>

      <div>
        <Label htmlFor="shortName">Nombre corto *</Label>
        <Input
          id="shortName"
          value={formData.shortName}
          onChange={(e) => onInputChange("shortName", e.target.value)}
          placeholder="Nombre corto interno"
          required
        />
      </div>

      <div>
        <Label htmlFor="name">Nombre</Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => onInputChange("name", e.target.value)}
          placeholder="Ej: Departamento 7E, Rooftop 7E, Loft 857"
        />
        <p className="text-sm text-muted-foreground mt-1">
          Nombre amigable para mostrar a huéspedes
        </p>
      </div>

      <div>
        <Label htmlFor="shortDescription">Descripción corta *</Label>
        <Textarea
          id="shortDescription"
          value={formData.shortDescription}
          onChange={(e) => onInputChange("shortDescription", e.target.value)}
          placeholder="Descripción corta para listados"
          rows={3}
          required
        />
      </div>

      <div>
        <Label htmlFor="longDescription">Descripción larga</Label>
        <Textarea
          id="longDescription"
          value={formData.longDescription}
          onChange={(e) => onInputChange("longDescription", e.target.value)}
          placeholder="Descripción detallada de la propiedad"
          rows={5}
        />
      </div>

      <div>
        <Label htmlFor="airbnbUrl">URL de Airbnb</Label>
        <Input
          id="airbnbUrl"
          value={formData.airbnbUrl}
          onChange={(e) => onInputChange("airbnbUrl", e.target.value)}
          placeholder="https://www.airbnb.com/..."
          type="url"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="price">Precio por noche (MXN) *</Label>
          <Input
            id="price"
            type="number"
            min="0"
            value={formData.price}
            disabled={!canEdit}
            onChange={(e) =>
              onInputChange("price", parseInt(e.target.value) || 0)
            }
            placeholder="0.0"
            required
          />
        </div>
        <div>
          <Label htmlFor="cleaningFee">Tarifa de limpieza (MXN)</Label>
          <Input
            id="cleaningFee"
            type="number"
            min="0"
            disabled={!canEdit}
            value={formData.cleaningFee}
            onChange={(e) =>
              onInputChange("cleaningFee", parseInt(e.target.value) || 0)
            }
            placeholder="0.0"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="rating">Calificación (0-5)</Label>
        <Input
          id="rating"
          type="number"
          step="0.01"
          min="0"
          max="5"
          disabled={!canEdit}
          value={formData.rating}
          onChange={(e) =>
            onInputChange("rating", parseFloat(e.target.value) || 0)
          }
          placeholder="Calificación promedio"
        />
      </div>

      <div>
        <Label htmlFor="propertyFloor">Piso del departamento</Label>
        <Input
          id="propertyFloor"
          value={formData.propertyFloor}
          onChange={(e) => onInputChange("propertyFloor", e.target.value)}
          placeholder="Ej: Planta baja, 2do piso, Roof garden"
        />
      </div>
    </div>
  );
};

export default PropertyBasicInfo;
